import React from 'react';
import { useAuth } from '../utils/AuthContext';
import PasswordField from './PasswordField';
import FormField from './common/FormField';
import { useForm } from './common/useForm';

const noop = () => {};

const LoginModal = ({
  onClose,
  onOpenForgot = noop,
  onOpenForgotPassword = noop,
  onOpenForgotUsername = noop,
  onOpenRegister = noop,
  onSuccess = noop
}) => {
  const { login } = useAuth();
  const [form, handleChange, setForm] = useForm({ username: '', password: '', remember: true });
  const [error, setError] = React.useState('');

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    try {
      await login(
        { username: form.username, password: form.password },
        { remember: form.remember }
      );
      onClose();
      onSuccess();
    } catch (requestError) {
      const responseData = requestError.response?.data;
      const validationMessage = Array.isArray(responseData?.errors)
        ? responseData.errors.map((item) => item.message).join(', ')
        : '';
      setError(validationMessage || responseData?.message || 'Нэвтрэх үед алдаа гарлаа');
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(event) => event.stopPropagation()}>
        <h3>Нэвтрэх</h3>
        <form className="form" onSubmit={submit}>
          <FormField
            type="input"
            label="Нэвтрэх нэр эсвэл и-мэйл"
            name="username"
            placeholder="Нэвтрэх нэр эсвэл и-мэйл"
            value={form.username}
            onChange={handleChange}
            required
          />
          <PasswordField
            placeholder="Нууц үг"
            value={form.password}
            onChange={e => handleChange({ target: { name: 'password', value: e.target.value } })}
            autoComplete="current-password"
          />
          <label className="remember-row">
            <FormField
              type="input"
              typeInput="checkbox"
              name="remember"
              checked={form.remember}
              onChange={handleChange}
            />
            <span>Remember</span>
          </label>
          {error && <p className="error">{error}</p>}
          <button type="submit">Нэвтрэх</button>
          <button
            type="button"
            className="modal-inline-link"
            onClick={() => {
              onClose();
              if (onOpenForgotPassword !== noop) {
                onOpenForgotPassword();
                return;
              }
              onOpenForgot();
            }}
          >
            Нууц үг мартсан
          </button>
          <button
            type="button"
            className="modal-inline-link"
            onClick={() => {
              onClose();
              if (onOpenForgotUsername !== noop) {
                onOpenForgotUsername();
                return;
              }
              onOpenForgot();
            }}
          >
            Нэвтрэх нэр мартсан
          </button>
          <button
            type="button"
            className="modal-inline-link"
            onClick={() => {
              onClose();
              onOpenRegister();
            }}
          >
            Хэрвээ та бүртгэлгүй бол бүртгүүлнэ үү
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginModal;
